'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import FileModalReadController from "./controller/fileModalRead";
import FileUploaderDirective from "./directive/fileUploader";

export default angular.module('investmentProject.file', [])
    .controller('FileModalReadController', FileModalReadController)
    .directive('fileUploader', FileUploaderDirective)
    .name;
